

















import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { setPageTitle } from '@/util/Helpers'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import EditorHeader from './header/EditorHeader.vue'
import EditorFields from './fields/EditorFields.vue'
import SharePanel from '../share/SharePanel.vue'
import RevisionPanel from '../revision/RevisionPanel.vue'

@Component({
    name: 'entry-editor',
    components: { EditorHeader, EditorFields, SharePanel, RevisionPanel }
    })
export default class EntryEditor extends Vue {
    shareCollapsed: boolean = true
    revisionsCollapsed: boolean = true

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    mounted(): void {
        setPageTitle(this.entry.fields.title.value || 'New entry')
    }

    toggleShare(value: boolean): void {
        this.shareCollapsed = value
        if (!value) {
            this.revisionsCollapsed = true
        }
    }

    toggleRevisions(value: boolean): void {
        this.revisionsCollapsed = value
        if (!value) {
            this.shareCollapsed = true
        }
    }
}
